import React from "react";

// Legacy Navbar is now a no-op because AppShell (via PrivateRoute) provides
// the topbar for all authenticated pages. Public pages (Login, ForgotPassword,
// LandingPage) render their own headers directly — they don't need a nav bar.
// Kept as a named export so existing `import Navbar from "..."` doesn't crash.
const Navbar = () => null;

export default Navbar;
